import { gql } from "@apollo/client";

export const ENVIAR_NOTIFICACION_CREDITICIA = gql`
    query enviarNotificacionCrediticia( $idEvaluacion: Int! ){
        enviarNotificacionCrediticia( idEvaluacion: $idEvaluacion ) {
            enviada
            fechaNotificacionCrediticia
        }
    }
`;

export const adaptNotifCrediticia = (data) => ({
  enviada: data?.enviarNotificacionCrediticia?.enviada,
  fechaNotificacionCrediticia: data?.enviarNotificacionCrediticia?.fechaNotificacionCrediticia
});